import {
  CtaBuilderFn,
  InstantAnswerBuilderFn,
  InstantAnswerContext,
  InstantAnswerScenario,
} from "@faire/help-center-self-serve/types";
import { getBrandToken } from "@faire/help-center-utils/serialized-data/getBrand";
import { StrictLocalizeFunction } from "@faire/web--source/common/localization";
import { trackHelpCenterPayoutIaCtaClick } from "@faire/web-api--source/events/helpCenter/click/payoutIaCta";
import { StringContextType } from "@faire/web-api--source/faire/translator/StringContextType";
import { path as getSelfServeRecommendedArticleRoute } from "@faire/web-api--source/routes/support/self-serve/recommended-article";
import * as H from "history";
import React from "react";

import { UpdatePayoutsIA } from "./instantAnswersComponents/payments/UpdatePayoutsIA";

export const updatePayouts: InstantAnswerBuilderFn = (strictLocalize) => ({
  titleBuilder: (context) => getAnswer(context, strictLocalize).getTitle(),
  descriptionBuilder: (context) =>
    getAnswer(context, strictLocalize).getDescription(),
  primaryCtaBuilder: {
    textBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.label;
    },
    onClickFunctionBuilder: (context) => {
      return getPrimaryCTA(context, strictLocalize)?.onClick;
    },
  },
});

const getAnswer = (
  context: InstantAnswerContext,
  strictLocalize: StrictLocalizeFunction
): InstantAnswerScenario => {
  return {
    getTitle: () => UPDATE_PAYOUTS_TITLE(strictLocalize),
    getDescription: () => UPDATE_PAYOUTS_DESCRIPTION(context),
  };
};

const UPDATE_PAYOUTS_TITLE = (strictLocalize: StrictLocalizeFunction) =>
  strictLocalize({
    defaultMessage: "Change your payout option",
    description: {
      text: "Title for the 'How payouts are calculated' instant answer",
    },
  });
const getPrimaryCTA: CtaBuilderFn = (context, strictLocalize) => {
  return {
    label: strictLocalize({
      defaultMessage: "Update payout option",
      description: {
        text: "CTA button to update the payout option in the account settings",
        stringDescriptors: [StringContextType.CALL_TO_ACTION],
      },
    }),
    onClick: (history) => {
      payoutUpdateOptionOnClick(history);
      trackHelpCenterPayoutIaCtaClick(
        getBrandToken() ?? "",
        context.brandOrder?.brand_order?.token ?? ""
      );
    },
  };
};

const UPDATE_PAYOUTS_DESCRIPTION = (context: InstantAnswerContext) => {
  const { brand } = context;
  return <UpdatePayoutsIA brand={brand} />;
};

const payoutUpdateOptionOnClick = (history?: H.History) => {
  history?.push(
    getSelfServeRecommendedArticleRoute({ payout_update_modal: "1" })
  );
};
